$(document).ready(function() {
 
  $('input:radio[name=seller_edit_gst_registeration]').change(function() {
        if ($(this).val() == 'YES') {
          $("#seller_edit_GST").show();
          $("#seller_edit_gst_check_error").hide();
          $("#seller_edit_GST_error").hide();
        } else {
          $("#seller_edit_GST").hide();
          $("#seller_edit_gst_check_error").hide();
          $("#seller_edit_GST_error").hide();
        }
	});
});


$(document).ready(function() {

  function showForm(formClassName) {
    var profileImgEditPopup = $('.seller-profile-edit-popup');
    profileImgEditPopup.bPopup({
      positionStyle: 'fixed',
      scrollBar: 'true',
      closeClass: 'modal__close',
    });

    // Show the required form
    $('.seller_edit_shipping_details_form').hide();
    $('.seller_edit_form_three').hide();
    $('.seller_edit_form_two').hide();
    $('.seller_edit_form_first').hide();
    $('.' + formClassName).fadeIn();
  }

  // Opening popup on click of edit(descripton) button
  $('#seller_profile_edit_button').click(function() {
    var profileImgEditPopup = $('.seller-profile-edit-popup');
    profileImgEditPopup.bPopup({
      positionStyle: 'fixed',
      scrollBar: 'true',
      closeClass: 'modal__close',
    });
  });

  $('#seller_about_edit_button').click(function() {
    showForm('seller_edit_form_first');
  });

  $('#seller_shipping_edit_button').click(function() {
    showForm('seller_edit_shipping_details_form');
  });

  $('#seller_policy_edit_button').click(function() {
    showForm('seller_edit_form_three');
  });
  $('#seller_bank_edit_button').click(function() {
    showForm('seller_edit_form_two');

    var hiddenPanVal = $('#pan_url').val();

    var hiddenChequeVal = $('#cheque_url').val();
    if (hiddenPanVal != "") {
      $('#pan_exist').html("PAN card already added").fadeIn();
    } else {
      $('#pan_exist').hide();
    }
    if (hiddenChequeVal != "") {
      $('#cheque_exist').html("Cheque already added").fadeIn();
    } else {
      $('#cheque_exist').hide();
    }

  });
  
  
  $('#seller_details').click(function(e) {
     e.preventDefault();
     if (policyValidation() && sellerBasicInfoValidation() && sellerBankInfoValidation()) 
     {
      showForm('seller_edit_form_first');    
     }
  });

   $('#seller_shipping').click(function(e) {
     e.preventDefault();
     if (policyValidation() && sellerBasicInfoValidation() && sellerBankInfoValidation() ) {
         showForm('seller_edit_shipping_details_form');}
  });
  
  $('#seller_policy').click(function(e) {
     e.preventDefault();
   if (policyValidation() && sellerBasicInfoValidation() && sellerBankInfoValidation()){
       showForm('seller_edit_form_three');}
  });
  
  $('#seller_bank_details').click(function(e) {
      e.preventDefault();
     if (policyValidation() && sellerBasicInfoValidation() && sellerBankInfoValidation() ){
      showForm('seller_edit_form_two');
     var hiddenPanVal = $('#pan_url').val();

      var hiddenChequeVal = $('#cheque_url').val();
      if (hiddenPanVal != "") {
        $('#pan_exist').html("PAN card already added").fadeIn();
      } else {
        $('#pan_exist').hide();
      }
      if (hiddenChequeVal != "") {
        $('#cheque_exist').html("Cheque already added").fadeIn();
      } else {
        $('#cheque_exist').hide();
      }
   }
  });


  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return "";
  }
  if (readCookie('business_name') !== null && $('#seller_name').length && readCookie('business_name').toLowerCase() == $('#seller_name').val().toLowerCase()) {
    var sameSellerLoggedIn = true;
  } else {
    var sameSellerLoggedIn = false;
  }

  // Changes depending on whether is the same seller logged in
  if (sameSellerLoggedIn) {
    $('#seller_about_edit_button').show();
    $('#seller_shipping_edit_button').show();
    $('#seller_policy_edit_button').show();
    $('#seller_bank_edit_button').show();
    $('#seller_change_pass').show();
  } else {
    $('#seller_about_edit_button').hide();
    $('#seller_shipping_edit_button').hide();
    $('#seller_policy_edit_button').hide();
    $('#seller_bank_edit_button').hide();
    $('#seller_change_pass').hide();
  }

  // For scrolling down to seller description 
  $('#scroll_about').click(function() {
    $('html, body').animate({
      scrollTop: $("#about_seller").offset().top - 80
    }, 1000);
  });

  // For scrolling down to check shop reviews
  $('#scroll_reviews').click(function() {
    $('html, body').animate({
      scrollTop: $("#shop-reviews").offset().top - 60
    }, 1000);
  });

  // For scrolling down to products
  $('#scroll_product').click(function() {
    $('html, body').animate({
      scrollTop: $(".collection__masonry-wrapper").offset().top - 70
    }, 1000);
  });

  //Checking seller logged based on that getting profile info
  if (readCookie('business_name') != null && $('#seller_name').length &&
    readCookie('business_name') == $('#seller_name').val()) {
    if (true) {
      var emailId = readCookie('seller_email');
      var business_name = $('#seller_name').val();
      var sessionId = readCookie('session_token');
      $.ajax({
        type: 'GET',
        url: "https://test-designers.lovethisstuff.com/sellerProfile/getCompleteProfileDataAPI?business_name=" + business_name + "&email=" + emailId + "&seller_session_id=" + sessionId,
        data: "",
        dataType: 'json',
        success: function(data) {
          if (data.messageType === "SESSION_EXPIRED") {
            console.log(data);
            //TODO say login expired 
            $('.api_success').hide();
            $('.api_error').html(message).fadeIn();
          } else if (data.messageType === "SUCCESS") {
            console.log(data);
            //TODO get data and populate required field
            if (typeof(data.data.SellerProfile) != "undefined" && data.data.SellerProfile !== null) {
              //Populating account info
              $('#seller_TIN').val(data.data.SellerProfile.tin);
              $('#seller_CST').val(data.data.SellerProfile.cst);
              $('#seller_edit_GST').val(data.data.SellerProfile.gst);
              $('#seller_brand_name').val(data.data.SellerProfile.brand_name);
              $('#seller_edit_gst_value').val(data.data.SellerProfile.gst);

               var $gstRadios = $('input:radio[name=seller_edit_gst_registeration]');
              if (data.data.SellerProfile.is_gst_registered_seller == "YES") {
                $gstRadios.filter('[value=YES]').prop('checked', true);
                $("#seller_edit_GST").show();

              } else if (data.data.SellerProfile.is_gst_registered_seller == "NO") {
                $gstRadios.filter('[value=NO]').prop('checked', true);
                $("#seller_edit_GST").hide();
              }

              var $radios = $('input:radio[name=who_bears_shipping_cost]');
              if (data.data.SellerProfile.who_bears_shipping_cost == "SELLER") {
                $radios.filter('[value=SELLER]').prop('checked', true);
                $(".who_will_bear_charges_customer").hide();

              } else if (data.data.SellerProfile.who_bears_shipping_cost == "CUSTOMER") {
                $radios.filter('[value=CUSTOMER]').prop('checked', true);
                $(".who_will_bear_charges_seller").hide();
              }


              /*    if (data.data.SellerProfile.who_bears_shipping_cost == "SELLER") {
                    $("#who_will_bear_charges").val("seller");
                    $(".who_will_bear_charges_customer").hide();

                  } else if (data.data.SellerProfile.who_bears_shipping_cost == "CUSTOMER") {
                    $("#who_will_bear_charges").val("customer");
                    $(".who_will_bear_charges_seller").hide();

                  } */

              var $radios = $('input:radio[name=shipping_choice]');
              if (data.data.SellerProfile.shipping_choice == "seller_shipping") {
                $radios.filter('[value=seller_shipping]').prop('checked', true);
                $(".ship_via_courier_information_needed").hide();
                $(".choose_shipping_method").hide();
                $(".choosen_shipping_method").show();
                $(".ship_via_courier_partner").hide();
                $("#shipping_choice_error").hide();

              } else if (data.data.SellerProfile.shipping_choice == "ship_via_courier_partner") {
                $radios.filter('[value=ship_via_courier_partner]').prop('checked', true);
                $(".choose_shipping_method").hide();
                $(".choosen_shipping_method").show();
                $(".seller_shipping").hide();
                $(".ship_via_courier_information_needed").show();
                $("#shipping_choice_error").hide();

              }

              if (typeof(data.data.SellerProfile.bankDetail) != "undefined" && data.data.SellerProfile.bankDetail !== null) {
                var accountInfo = data.data.SellerProfile.bankDetail;
                $('#seller_pan_card_no').val(accountInfo.pan_card);
                $('#account_holder_name').val(accountInfo.account_holder_name);
                $('#bank_ifsc_code').val(accountInfo.ifsc_code);
                $('#bank_account_no').val(accountInfo.account_number);
                $('select#bank_name>option[value="' + accountInfo.bank_name + '"]').attr('selected', true);
                $('select#account_type>option[value="' + accountInfo.account_type + '"]').attr('selected', true);
              

                
                if (typeof(accountInfo.pan_url) != "undefined" && accountInfo.pan_url !== null) {
                  $('#pan_url').val(accountInfo.pan_url);
                  panUrl = accountInfo.pan_url;
                }
                if (typeof(accountInfo.cheque_url) != "undefined" && accountInfo.cheque_url !== null) {
                  $('#cheque_url').val(accountInfo.cheque_url);
                }
              }

              if (typeof(data.data.SellerProfile.shippingPickupAddress) != "undefined" && data.data.SellerProfile.shippingPickupAddress !== null) {
                var shippingPickupAddress = data.data.SellerProfile.shippingPickupAddress;
                $('#shipping_pickup_address').val(shippingPickupAddress.address);
                $('#shipping_pickup_address_city').val(shippingPickupAddress.city);
                $('#shipping_pickup_address_pincode').val(shippingPickupAddress.pincode);
                $('#shipping_pickup_address_state').val(shippingPickupAddress.state);
                $('#shipping_pickup_phone_number').val(shippingPickupAddress.phone_number);
                $('#shipping_pickup_name').val(shippingPickupAddress.name);
              }

              //Populating seller policy
              if (typeof(data.data.SellerProfile.policy) != "undefined" && data.data.SellerProfile.policy !== null) {
                var sellerPolicy = data.data.SellerProfile.policy;
                var showContactMe = false;
                $('#seller_no_of_days').val(sellerPolicy.number_of_days);
                if (sellerPolicy.accept_return == 'YES') {
                  showContactMe = true;
                  $('#seller_accept_returns').prop('checked', true);
                } else {
                  $('#seller_accept_returns').prop('checked', false);
                }

                if (sellerPolicy.accept_exchange == 'YES') {
                  showContactMe = true;
                  $('#seller_accept_exchange').prop('checked', true);
                } else {
                  $('#seller_accept_exchange').prop('checked', false);
                }

                /* Changing seller return condoitions to radio buttons */
                if (showContactMe) {
                  $('#seller_conditions_of_return_or_exchange').show();

                  var $radioButtons = $('input:radio[name=seller_profile_returns_condition]');

                  if (sellerPolicy.return_exchange_reason == "DAMAGE") {

                    $radioButtons.filter('[value=accept_returns_condition]').prop('checked', true);

                  } else if (sellerPolicy.return_exchange_reason == "SIZE") {

                    $radioButtons.filter('[value=accept_exchange_size_condition]').prop('checked', true);

                  }

                }

                if (sellerPolicy.use_contact_for_communication == 'YES') {
                  $('#seller_use_communication').prop('checked', true);
                } else {
                  $('#seller_use_communication').prop('checked', false);
                }

                if (sellerPolicy.use_contact_for_fulfilling_order == 'YES') {
                  $('#seller_use_fulfilling_order').prop('checked', true);
                } else {
                  $('#seller_use_fulfilling_order').prop('checked', false);
                }

                if (sellerPolicy.use_contact_for_legal == 'YES') {
                  $('#seller_use_for_legal').prop('checked', true);
                } else {
                  $('#seller_use_for_legal').prop('checked', false);
                }

                var non_returnable_item_array = [];
                if (sellerPolicy.return_custom_items == 'YES') {
                  non_returnable_item_array.push('return_custom_items');
                }
                if (sellerPolicy.return_perishable_items == 'YES') {
                  non_returnable_item_array.push('return_perishable_items');
                }
                if (sellerPolicy.return_intimate_items == 'YES') {
                  non_returnable_item_array.push('return_intimate_items');
                }
                if (sellerPolicy.return_digital_items == 'YES') {
                  non_returnable_item_array.push('return_digital_items');
                }
                if (sellerPolicy.return_sale_items == 'YES') {
                  non_returnable_item_array.push('return_sale_items');
                }
                // Then refresh
                $('#items_non-returnable').dropdown('set selected', non_returnable_item_array);
              }
            }

          } else if (data.messageType === "FAILURE") {
            //TODo any other failure show error message
          }
        },
        error: function(data) {},
        cache: false,
        contentType: false,
        processData: false
      });
    }
  }

  //Validating change password form
  function changePasswordValidation() {
    var OldPassword = $('#old_password').val();
    var NewPassword = $('#new_password').val();
    var NewPasswordConfirm = $('#new_password_confirm').val();

    $(".error_tag").hide();
    if (OldPassword != "" && NewPassword != "") {
      if (OldPassword == "") {
        $('#old_password').focus();
        $("#old_password_error").fadeIn().html("Please enter current Password");
        return false;
      }
      if (NewPassword == "") {
        $('#new_password').focus();
        $("#new_password_error").fadeIn().html("Please enter new Password");
        return false;
      } else if ((NewPassword.length) <= 5) {
        $('#new_password').focus();
        $("#new_password_error").fadeIn().html("Please enter minimum 6 character password");
        return false;
      }
      if (NewPasswordConfirm == "") {
        $('#new_password_confirm').focus();
        $("#new_password_confirm_error").fadeIn().html("Please re enter your new Password");
        return false;
      } else if ((NewPasswordConfirm.length) <= 5) {
        $('#new_password_confirm').focus();
        $("#new_password_confirm_error").fadeIn().html("Please enter minimum 6 character password");
        return false;
      } else if (NewPasswordConfirm != NewPassword) {
        $('#new_password_confirm').focus();
        $("#new_password_confirm_error").fadeIn().html("Your new password does not match");
        return false;
      }
    }
    return true;
  }


  //Validating Basic info form
  function sellerBasicInfoValidation() {
    var description = $('#seller_description_input').val();
    var brand_name = $('#seller_brand_name').val();
    var youtube_url = $('#seller_video_url_input').val();
    var facebook_url = $('#seller_facebook_url_input').val();
    var instagram_url = $('#seller_instagram_url_input').val();
    var pinterest_url = $('#seller_pinterest_url_input').val();
    var description_length = $('#seller_description_input').val().split(" ").length;
    var minimumWords = 50;
    $(".error_tag").hide();
    if (description == "") {
      $('#seller_description_input').focus();
      $("#seller_description_text_error").html("Please enter something about your shop").fadeIn();
      return false;
    } else if (description_length < minimumWords) {
      $('#seller_description_input').focus();
      $("#seller_description_text_error").html("Please enter minimum 50 words").fadeIn();
      return false;
    }
    
    if (brand_name == "") {
      $('#seller_brand_name').focus();
      $("#seller_brand_name_error").html("Please enter brand name of  your shop").fadeIn();
      return false;
    }


    if (youtube_url != "" & youtube_url.indexOf('youtube.com') == -1) {
      $('#seller_video_url_input').focus();
      $("#seller_video_error").html("Please enter valid youtube url").fadeIn();
      return false;
    }
    if (facebook_url != "" & facebook_url.indexOf('facebook.com') == -1) {
      $('#seller_facebook_url_input').focus();
      $("#seller_facebook_url_error").html("Please enter valid facebook url").fadeIn();
      return false;
    }
    if (instagram_url != "" & instagram_url.indexOf('instagram.com') == -1) {
      $('#seller_instagram_url_input').focus();
      $("#seller_instagram_url_error").html("Please enter valid instagram url").fadeIn();
      return false;
    }
    if (pinterest_url != "" & pinterest_url.indexOf('pinterest.com') == -1) {
      $('#seller_pinterest_url_input').focus();
      $("#seller_pinterest_url_error").html("Please enter valid pinterest url").fadeIn();
      return false;
    }
    return true;
  }


  //Validating bank info form
  function sellerBankInfoValidation() {
    var bankName = $('#bank_name').val();
    var sellerPanCardNo = $('#seller_pan_card_no').val();
    var accountHolderName = $('#account_holder_name').val();
    var bankIfscCode = $('#bank_ifsc_code').val();
    var accountType = $('#account_type').val();
    var bankAccountNo = $('#bank_account_no').val();
    var panCardScanCopy = $('#pan_card_scan_copy').val();
    var chequeScanCopy = $('#chequebook_scan_copy').val();
    var hiddenPanVal = $('#pan_url').val();
    var hiddenChequeVal = $('#cheque_url').val();
    var panCardPattern = /^([a-zA-Z]{5})(\d{4})([a-zA-Z]{1})$/;
    var ifscPattern = /[A-Z|a-z]{4}[0][\d]{6}$/;
    // var panFileSize = $('#pan_card_scan_copy')[0].files[0].size;
    //var chequeFileSize = $('#chequebook_scan_copy')[0].files[0].size;



    $(".error_tag").hide();
    if (bankName == null) {
      $('#bank_name').focus();
      $("#bank_name_error").html("Please select bank name").fadeIn();
      return false;
    }

    if (sellerPanCardNo == "") {
      $('#seller_pan_card_no').focus();
      $("#pan_card_error").html("Please enter pan card number").fadeIn();
      return false;
    } else if (sellerPanCardNo != "" && sellerPanCardNo.search(panCardPattern) == -1) {
      $('#seller_pan_card_no').focus();
      $("#pan_card_error").html("Please enter valid pan card number").fadeIn();
      return false;
    }
    if (accountHolderName == "") {
      $('#account_holder_name').focus();
      $("#account_holder_name_error").html("Please enter account holder name").fadeIn();
      return false;
    }
    if (bankIfscCode == "") {
      $('#bank_ifsc_code').focus();
      $("#bank_ifsc_code_error").html("Please enter IFSC code").fadeIn();
      return false;
    } else if (bankIfscCode != "" && bankIfscCode.search(ifscPattern) == -1) {
      $('#bank_ifsc_code').focus();
      $("#bank_ifsc_code_error").html("Please enter valid IFSC code").fadeIn();
      return false;
    }
    if (accountType == null) {
      $('#account_type').focus();
      $("#account_type_error").html("Please select account type").fadeIn();
      return false;
    }
    if (bankAccountNo == "") {
      $('#bank_account_no').focus();
      $("#bank_account_no_error").html("Please enter bank account number").fadeIn();
      return false;
    } else if (!$.isNumeric(bankAccountNo)) {
      $('#bank_account_no').focus();
      $("#bank_account_no_error").html("Please enter only numbers").fadeIn();
      return false;
    }
    if (hiddenPanVal == "") {
      if (panCardScanCopy == "") {
        $('#pan_card_scan_copy').focus();
        $('#pan_card_scan_copy_error').html("Please upload scan copy of your PAN card").fadeIn();
        return false;
      }
      /* else if(panFileSize>5000000) {
      		$('#pan_card_scan_copy').focus();
            	$('#pan_card_scan_copy_error').html("Please upload file less than 5MB").fadeIn();
            	return false;
      		} */
    }
    if (hiddenChequeVal == "") {
      if (chequeScanCopy == "") {
        $('#chequebook_scan_copy').focus();
        $('#chequebook_scan_copy_error').html("Please upload scan copy of Cheque").fadeIn();
        return false;
      }
      /* else if(chequeFileSize>5000000) {
		$('#chequebook_scan_copy').focus();
      	$('#chequebook_scan_copy_error').html("Please upload file less than 5MB").fadeIn();
      	return false;
	} */
    }
    return true;
  }



  //If seller accepts returns of exchange show the conditions.


  $("#seller_accept_returns").click(function() {
    if ($("#seller_accept_returns").is(":checked") || $("#seller_accept_exchange").is(":checked")) {
      $('#seller_conditions_of_return_or_exchange').show();
    } else {
      $('#seller_conditions_of_return_or_exchange').hide();
    }
  });

  $("#seller_accept_exchange").click(function() {
    if ($("#seller_accept_returns").is(":checked") || $("#seller_accept_exchange").is(":checked")) {
      $('#seller_conditions_of_return_or_exchange').show();
    } else {
      $('#seller_conditions_of_return_or_exchange').hide();
    }
  });



  //Policy validation
  function policyValidation() {
    if ($("#seller_accept_returns").is(":checked") || $("#seller_accept_exchange").is(":checked")) {
      if ($('#seller_no_of_days').val() == null) {
        $('#seller_no_of_days').focus();
        $("#contact_days_error").html("Please select no of days").fadeIn();
        return false;
      }

      if ($('input[name=seller_profile_returns_condition]:checked').length <= 0) {
        $('#seller_edit_return_conditions').focus();
        $('#seller_returns_condition_error').html("Please select one of the condition").fadeIn();
        return false;
      }

    }
    return true;
  }
  //showing contact me selector based on checkbox click event
  $('#seller_accept_returns, #seller_accept_exchange').change(function() {
    if ($('#seller_accept_exchange').is(':checked') || $('#seller_accept_returns').is(':checked')) {

      $('#seller_conditions_of_return_or_exchange').show();

    } else {
      $('#seller_conditions_of_return_or_exchange').fadeOut();

    }
  });

  // Toggle update form shipping tab
  $('#next_edit_form_two').click(function(e) {
    e.preventDefault();
    //Validating form
    if (sellerBasicInfoValidation()) {
      $('.seller_edit_form_first').hide();
      $('.seller_edit_shipping_details_form').fadeIn();
    }
  });

  $('#seller_edit_shipping_details_back').click(function(e) {
    e.preventDefault();
    //Validating form

    $('.seller_edit_shipping_details_form').hide();
    $('.seller_edit_form_first').fadeIn();
  });

  $('input[type="radio"]').click(function() {
    if ($(this).attr("value") == "seller_shipping") {
      $(".ship_via_courier_information_needed").hide();
      $("#shipping_choice_error").hide();
    }
    if ($(this).attr("value") == "ship_via_courier_partner") {
      $("#shipping_choice_error").hide();
      $(".ship_via_courier_information_needed").show();
    }
  });


  // Toggle update form details tab
  $('#seller_edit_shipping_details_next').click(function(e) {
    e.preventDefault();
    //Validating form
    if (shippingPickupAddressValidation()) {
      $('.seller_edit_shipping_details_form').hide();
      $('.seller_edit_form_three').fadeIn();

    }


  });

  // Show product details tab
  $('#back_to_edit_one').click(function(e) {
    e.preventDefault();
    $('.seller_edit_form_three').hide();
    $('.seller_edit_shipping_details_form').fadeIn();
  });


  $('#next_edit_form_three').click(function(e) {
    e.preventDefault();

    //Validating form
    if (policyValidation()) {

      $('.seller_edit_form_three').hide();
      $('.seller_edit_form_two').fadeIn();

      var hiddenPanVal = $('#pan_url').val();
      var hiddenChequeVal = $('#cheque_url').val();
      if (hiddenPanVal != "") {
        $('#pan_exist').html("PAN card already added").fadeIn();
      } else {
        $('#pan_exist').hide();
      }
      if (hiddenChequeVal != "") {
        $('#cheque_exist').html("Cheque already added").fadeIn();
      } else {
        $('#cheque_exist').hide();
      }
    }

  });

  // Show product details tab
  $('#back_to_edit_two').click(function(e) {
    e.preventDefault();
    $('.seller_edit_form_two').hide();
    $('.seller_edit_form_three').fadeIn();
  });

  //Saving seller profile data
  $("#update_seller_button").click(function(e) {
    e.preventDefault();
    if (sellerBankInfoValidation()) {
      $(".loding_container").fadeIn();
      var updateSellerSubmitBtn = $('#update_seller_button'); // submit button
      updateSellerSubmitBtn.html('Saving...');
      updateSellerSubmitBtn.prop('disabled', true); // disable button
      updateSellerSubmitBtn.attr("disabled", true); // disable button
      var formData = new FormData($("#seller_update_form")[0]);
      var business_name = $('#seller_name').val();
      var emailId = readCookie('seller_email');
      var sessionId = readCookie('session_token');
      var PAN = $('#PAN_image_file').val();

      formData.append('business_name', business_name);
      formData.append('email', emailId);
      formData.append('seller_session_id', sessionId);

      var PAN_image_file = $("#pan_card_scan_copy")[0].files[0];
      console.log("PAN");
      console.log(PAN_image_file);
      formData.append("pan_card_scan_copy", PAN_image_file);

      var cheque_image_file = $("#chequebook_scan_copy")[0].files[0];
      console.log("cheque");
      console.log(cheque_image_file);
      formData.append("chequebook_scan_copy", cheque_image_file);
      // formData.append('PAN',PAN);
      //Adding extra data
      formData.append('ajaxRequest', 'yes');
      $.ajax({
        url: "https://test-designers.lovethisstuff.com/sellerProfile/updateProfileDetails",
        type: 'POST',
        data: formData,
        processData: false,
        async: false,
        beforeSend: function() {
          updateSellerSubmitBtn.html('Saving ...');
          updateSellerSubmitBtn.prop('disabled', true); // disable button
          updateSellerSubmitBtn.attr('disabled', true); // disable button
        },
        success: function(data) {
          console.log(data);
          var messageType = data.messageType;
          var message = data.message;
          $(".loding_container").fadeOut();
          updateSellerSubmitBtn.prop('disabled', false); // disable button
          updateSellerSubmitBtn.attr('disabled', false); // disable button
          if (messageType == 'FAILURE') {
            updateSellerSubmitBtn.html('Submit'); // change submit button text
            $('.api_success').hide();
            $('.api_error').html(message).fadeIn();
          } else if (messageType === "SUCCESS") {
            updateSellerSubmitBtn.html('Saved');
            //create the cookie to add product after update.
            createCookie('seller_required_information', 'complete');

            $('.api_success').html(data.message);
            $('.api_error').hide();
            $('.api_success').fadeIn();
            setTimeout(function() {
              location.reload();
            }, 1000);

          }
        },
        error: function(data) {
          $(".loding_container").fadeOut();
          updateSellerSubmitBtn.html('Submit'); // change submit button text
          updateSellerSubmitBtn.attr("disabled", false); // Enabling button
          updateSellerSubmitBtn.prop('disabled', false); // disable button
          $('.api_error').html(data.message);
          $('.api_success').hide();
          $('.api_error').fadeIn();
        },
        cache: false,
        contentType: false,
        processData: false
      });
      return false;
    }
  });


  function shippingPickupAddressValidation() {
    
    var sellerGstEdit = $('#seller_edit_gst_value').val();
    var gstFormat = /^[a-zA-Z0-9_]*$/;
    var uppercaseSellerGstEdit = sellerGstEdit.toUpperCase();
    
    if ($("input[name='seller_edit_gst_registeration']:checked").val() == "YES") {
      
        if (uppercaseSellerGstEdit == "" ){
 			$('#seller_edit_gst').focus();
            $("#seller_edit_GST_error").html("Please enter your GST number.").fadeIn();
            return false;
        } else if (uppercaseSellerGstEdit != "") {
          if (!gstFormat.test(uppercaseSellerGstEdit)) {
            $('#seller_edit_gst').focus();
            $("#seller_edit_GST_error").html("Please provide a valid GST number.").fadeIn();
            return false;
          }
        }
	}
    
     if ($('input[name=seller_edit_gst_registeration]:checked').length <= 0) {
       $('.seller_edit_gst_registered').focus();
       $('#seller_edit_gst_check_error').html("Please select gst option").fadeIn();
      return false;
    }
    
    if ($('input[name=shipping_choice]:checked').length <= 0) {
      $('#shipping_choice_error').html("Please select your shipping choice").fadeIn();
      return false;
    } else if ($("input[name='shipping_choice']:checked").val() == "ship_via_courier_partner") {

      var sellerTin = $('#seller_TIN').val();
      var sellerCst = $('#seller_CST').val();
      var shippingPickupAddress = $('#shipping_pickup_address').val();
      var shippingPickupCity = $('#shipping_pickup_address_city').val();
      var shippingPickupPincode = $('#shipping_pickup_address_pincode').val();
      var shippingPickupstate = $('#shipping_pickup_address_state').val();
      var shippingPickupPhoneNumber = $('#shipping_pickup_phone_number').val();
      var shippingPickupName = $('#shipping_pickup_name').val();
      $(".error_tag").hide();

      if (sellerTin == "") {
        $('#seller_TIN').focus();
        $("#seller_TIN_error").html("Enter your TIN number").fadeIn();
        return false;
      }
      if (sellerCst == "") {
        $('#seller_CST').focus();
        $("#seller_CST_error").html("Enter your CST number").fadeIn();
        return false;
      }

      if (shippingPickupAddress == "") {
        $('#shipping_pickup_address').focus();
        $("#shipping_pickup_address_error").html("Enter your shipping pickup address").fadeIn();
        return false;
      }
      if (shippingPickupCity == "") {
        $('#shipping_pickup_address_city').focus();
        $("#shipping_pickup_address_city_error").html("Enter your city").fadeIn();
        return false;
      }
      if (shippingPickupPincode == "") {
        $('#shipping_pickup_address_pincode').focus();
        $("#shipping_pickup_address_pincode_error").html("Enter your pin code").fadeIn();
        return false;
      } else if (!$.isNumeric(shippingPickupPincode)) {
        $('#shipping_pickup_address_pincode').focus();
        $("#shipping_pickup_address_pincode_error").html("Enter only numbers").fadeIn();
        return false;
      } else if (shippingPickupPincode.length != 6) {
        $('#shipping_pickup_address_pincode').focus();
        $("#shipping_pickup_address_pincode_error").html("Enter valid pin code").fadeIn();
        return false;
      }
      if (shippingPickupstate == "") {
        $('#shipping_pickup_address_state').focus();
        $("#shipping_pickup_address_state_error").html("Enter your state").fadeIn();
        return false;
      }
      if (shippingPickupPhoneNumber == "") {
        $('#shipping_pickup_phone_number').focus();
        $("#shipping_pickup_phone_number_error").html("Enter your phone number").fadeIn();
        return false;
      } else if (!$.isNumeric(shippingPickupPhoneNumber)) {
        $('#shipping_pickup_phone_number').focus();
        $("#shipping_pickup_phone_number_error").html("Enter only number").fadeIn();
        return false;
      } else if (shippingPickupPhoneNumber.length != 10) {
        $('#shipping_pickup_phone_number').focus();
        $("#shipping_pickup_phone_number_error").html("Enter valid mobile number").fadeIn();
        return false;
      }
      if (shippingPickupName == "") {
        $('#shipping_pickup_name').focus();
        $("#shipping_pickup_name_error").html("Enter shipping pickup contact name").fadeIn();
        return false;
      }

      return true;
    }

    return true;

  }


});
